import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { GovernmentApplicationConfirmationSearchSchema } from './government-application-confirmation/-zod-schema';

export const Route = createFileRoute(
  '/_staff/labor-core/government-application-confirmation',
)({
  validateSearch: zodValidator(GovernmentApplicationConfirmationSearchSchema),
});
